import React from 'react';
import PropTypes from 'prop-types';
import EnhancedRaisedButton from './EnhancedRaisedButton';
import translate from 'components/hoc/translate';

const SignInButton = (props) => {
    const {
        disabled,
        fullWidth,
        loading,
        primary,
        translate,
    } = props;

    return (
        <EnhancedRaisedButton
            disabled={ disabled }
            fullWidth={ fullWidth }
            label={ translate('actions.signIn') }
            loading={ loading }
            primary={ primary }
            type='submit'
        />
    );
};

SignInButton.defaultProps = {
    disabled: false,
    fullWidth: false,
    loading: false,
    primary: true,
};

SignInButton.propTypes = {
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    loading: PropTypes.bool,
    primary: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default translate(SignInButton);



// WEBPACK FOOTER //
// ./src/components/button/SignInButton.js